var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSolidOnLight(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 25C1 11.745 11.745 1 25 1s24 10.745 24 24-10.745 24-24 24S1 38.255 1 25z",
    fill: "#FFEB46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 25h14m0 0l-7-7m7 7l-7 7",
    stroke: "#121318",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 48C12.297 48 2 37.703 2 25H0c0 13.807 11.193 25 25 25v-2zm23-23c0 12.703-10.297 23-23 23v2c13.807 0 25-11.193 25-25h-2zM25 2c12.703 0 23 10.297 23 23h2C50 11.193 38.807 0 25 0v2zm0-2C11.193 0 0 11.193 0 25h2C2 12.297 12.297 2 25 2V0z",
    fill: "#FFEB46"
  })));
}

export default SvgSolidOnLight;